import { NavigationMenu } from "@base-ui/react/navigation-menu";
import { Avatar } from "../../Avatar";
import { IconCloseMenu, IconMenu } from "../../icons";
import { ScrollArea } from "../../ScrollArea";
import { MenuSubitem } from "../MenuSubitem";
import {
  menuHeaderClass,
  menuHeaderIconContainerClass,
  menuHeaderOpenClass,
  menuModalStyleClass,
  menuPopupWrapperClass,
  menuViewportClass,
  modalHeaderClass,
  profileImageClass,
  resetListClass,
} from "../styles.css";
import type { ProfileItemProps } from "../types";

interface MenuHeaderProps {
  sideBarOpen: boolean;
  profile: ProfileItemProps;
  onToggleSidebar: () => void;
}

export const MenuHeader = ({
  sideBarOpen,
  profile,
  onToggleSidebar,
}: MenuHeaderProps) => {
  const hasSubitems = profile.subitems && profile.subitems.length > 0;

  return (
    <div
      className={`${menuHeaderClass} ${sideBarOpen ? menuHeaderOpenClass : ""}`}
    >
      <button
        onClick={onToggleSidebar}
        className={menuHeaderIconContainerClass}
        aria-label={sideBarOpen ? "Fechar menu" : "Abrir menu"}
        style={{ border: "none", background: "none" }}
      >
        {sideBarOpen ? (
          <IconCloseMenu id="icon-menu" />
        ) : (
          <IconMenu id="icon-menu" />
        )}
      </button>

      {sideBarOpen && <span>{profile.name}</span>}

      {hasSubitems ? (
        <NavigationMenu.Root delay={0} closeDelay={100} orientation="vertical">
          <NavigationMenu.List className={resetListClass}>
            <NavigationMenu.Item className={resetListClass}>
              <NavigationMenu.Trigger
                className={profileImageClass}
                style={{
                  background: "none",
                  padding: 0,
                  borderRadius: "50%",
                  display: "inline-flex",
                }}
              >
                <Avatar
                  src={profile.image ?? undefined}
                  alt={profile.name}
                  size={50}
                />
              </NavigationMenu.Trigger>
              <NavigationMenu.Content className={menuModalStyleClass}>
                <span className={modalHeaderClass}>{profile.name}</span>
                <ScrollArea maxHeight="calc(100vh - 48px)">
                  <div>
                    {profile.subitems?.map((subitem) => (
                      <MenuSubitem
                        key={`profile-subitem-${subitem.text}`}
                        subitem={subitem}
                        parentPath={profile.path}
                      />
                    ))}
                  </div>
                </ScrollArea>
              </NavigationMenu.Content>
            </NavigationMenu.Item>
          </NavigationMenu.List>
          <NavigationMenu.Portal>
            <NavigationMenu.Positioner
              sideOffset={4}
              side="right"
              align="start"
              collisionAvoidance={{ align: "none" }}
              style={{ zIndex: 10 }}
            >
              <NavigationMenu.Popup className={menuPopupWrapperClass}>
                <NavigationMenu.Viewport className={menuViewportClass} />
              </NavigationMenu.Popup>
            </NavigationMenu.Positioner>
          </NavigationMenu.Portal>
        </NavigationMenu.Root>
      ) : (
        <Avatar
          src={profile.image ?? undefined}
          alt={profile.name}
          size={50}
          className={profileImageClass}
        />
      )}
    </div>
  );
};
